var Share = function Share() {
	new ShareButton({
		networks: {
			pinterest: {
				enabled: false
			},
			reddit: {
				enabled: false
			},
			whatsapp: {
				enabled: false
			}
		},
		ui: {
			flyout: 'middle left'
		}
	});
}

module.exports = Share;